import { ClientEventBus } from './ClientEventBus';
export class InMemoryProductionClientEventGateway extends ClientEventBus {
    sendEvents(events) {
        return Promise.all(events.map(event => this.sendEvent(event)))
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    sendEvent(event) {
        console.log('NEW EVENT', event);
        return this.onEvent(event);
    }
}
